import { render, staticRenderFns } from "./TableSelectProduct.vue?vue&type=template&id=1a889032&scoped=true"
import script from "./TableSelectProduct.vue?vue&type=script&lang=js"
export * from "./TableSelectProduct.vue?vue&type=script&lang=js"
import style0 from "./TableSelectProduct.vue?vue&type=style&index=0&id=1a889032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a889032",
  null
  
)

export default component.exports